import React from 'react'
import PropTypes from 'prop-types'

import { Checkbox } from 'react-bootstrap'
import Util from './Util'
import { NumericInput, LabelGroup, Flex } from '../../views';

export default class RhumbInterpolatorEditor extends React.Component {

  static TYPE = 'rhumb'

  static propTypes = {
    interpolator : PropTypes.object.isRequired,
    attributeType : PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.changePath = Util.ChangePath.bind( this )
  }

  render() {
    const { interpolator : mdl } = this.props
    if ( mdl == null ) {
      return <div />
    }

    return (
      <Flex variant="vSpace" direction="column" align="stretch">

        <LabelGroup>
          <label>Update every</label>
          <div>
            <NumericInput
              hint="Seconds..." 
              value={mdl.update == null ? 0 : mdl.update / 1000}
              float
              size={5}
              min={0}
              onChange={( v, err ) => { this.changePath( 'update', typeof v === 'number' ? v * 1000 : v, err ) }} />
            <label style={{ margin : '0 8px' }}> seconds</label>
          </div>
        </LabelGroup>
      </Flex>
    ) 
  }
}
